import { useTheme } from '@mui/material/styles';
import { Cardio, Restore, Strength, YogaPose } from '@onesource/icons';
import { CategoryEnum, ContentBlockContentCategoryType } from '@onesource/schemas';
import { FC } from 'react';

export interface IContentCategoryBadgeProps {
  category: ContentBlockContentCategoryType | null;
  color?: 'primary' | 'secondary';
  size?: 'small' | 'medium' | 'large';
}

export const ContentCategoryBadge: FC<IContentCategoryBadgeProps> = props => {
  const { size = 'large', category, color = 'primary' } = props;
  const theme = useTheme();

  const sizes = {
    large: {
      iconSize: 24,
    },
    medium: {
      iconSize: 15,
    },
    small: {
      iconSize: 12,
    },
  };

  return (
    <>
      {category === CategoryEnum.STRENGTH && (
        <Strength fontSize={sizes[size].iconSize} color={theme.palette[color].main} />
      )}
      {category === CategoryEnum.CARDIO && <Cardio fontSize={sizes[size].iconSize} color={theme.palette[color].main} />}
      {category === CategoryEnum.FLOW && <YogaPose fontSize={sizes[size].iconSize} color={theme.palette[color].main} />}
      {category === CategoryEnum.RESTORE && (
        <Restore fontSize={sizes[size].iconSize} color={theme.palette[color].main} />
      )}
    </>
  );
};
